import React from 'react';

import FormCompositionIdentification, {
  CompositionIdentification as CompositionIdentificationParams,
} from './Form';

interface IdentificationProps {
  saving: boolean;
  loading: boolean;
  initialData: CompositionIdentificationParams;
  onSubmit: (data: CompositionIdentificationParams) => void;
  isEditing?: boolean;
  isFromModal?: boolean;
  budgetBaseOptions?: React.ComponentProps<
    typeof FormCompositionIdentification
  >['budgetBaseOptions'];
  isKindLocked?: boolean;
  fixedKind?: CompositionIdentificationParams['kind'];
  hideKindField?: boolean;
  disableBaseVersionWhenInitialData?: boolean;
  showQuantityField?: boolean;
}

const CompositionIdentification: React.FC<IdentificationProps> = ({
  saving,
  loading,
  initialData,
  onSubmit,
  ...restProps
}) => {
  const handleSubmit = (data: CompositionIdentificationParams): void => {
    onSubmit(data);
  };

  return (
    <FormCompositionIdentification
      onSubmit={handleSubmit}
      saving={saving}
      loading={loading}
      initialData={initialData}
      isEditing={restProps.isEditing ?? false}
      {...restProps}
    />
  );
};

export default CompositionIdentification;
